import React, { Component } from 'react'

class ContactForm extends Component {
    state = {
        name: '',
        email: '',
        subject: '',
        lastname: '',
        events: '',
        notes: '',
        message: '',
        error: {},
        isSubmitting: false,
        submitStatus: '' // 'success' or 'error'
    }

    changeHandler = (e) => {
        const error = this.state.error;
        error[e.target.name] = ''

        this.setState({
            [e.target.name]: e.target.value,
            error,
            submitStatus: ''
        })
    }

    submitHandler = async (e) => {
        e.preventDefault();

        const { name, email, subject, lastname, events, notes, message} = this.state;

        // Reset errors
        const newError = {};

        // Validation
        if (name === '') {
            newError.name = "Please enter your name";
        }
        if (email === '') {
            newError.email = "Please enter your email";
        }
        if (subject === '') {
            newError.subject = "Please enter your subject";
        }
        if (lastname === '') {
            newError.lastname = "Please enter your Lastname";
        }
        if (message === '') {
            newError.message = "Please enter your message";
        }

        // If there are errors, update state and return
        if (Object.keys(newError).length > 0) {
            this.setState({ error: newError });
            return;
        }

        // If no errors, submit to Google Sheets
        this.setState({ isSubmitting: true, error: {} });

        try {
            const response = await this.submitToGoogleSheets();
            
            if (response.ok) {
                this.setState({
                    name: '',
                    email: '',
                    subject: '',
                    lastname: '',
                    message: '',
                    isSubmitting: false,
                    submitStatus: 'success'
                });
            } else {
                throw new Error('Failed to submit form');
            }
        } catch (error) {
            this.setState({
                isSubmitting: false,
                submitStatus: 'error'
            });
        }
    }

    submitToGoogleSheets = async () => {
        const { name, email, subject, lastname, message } = this.state;

        // Your Google Apps Script URL - REPLACE THIS WITH YOUR ACTUAL URL
        const scriptURL = 'https://script.google.com/macros/s/AKfycbw-JRdW3ortMml5zjah1FpPnO4S-eRsthDLvK8wY6H_SEcG2n-LiZZ8_Al-b0kmBiJVIg/exec';

        const formData = new FormData();
        formData.append('Name', name);
        formData.append('Email', email);
        formData.append('Subject', subject);
        formData.append('Lastname', lastname);
        formData.append('Message', message);
        formData.append('timestamp', new Date().toISOString());

        console.log('Submitting to Google Sheets with data:', { name, email, subject, lastname, message });

        try {
            const response = await fetch(scriptURL, {
                method: 'POST',
                body: formData
            });

            console.log('Response status:', response.status);
            console.log('Response ok:', response.ok);

            const responseText = await response.text();
            console.log('Response text:', responseText);

            return response;
        } catch (error) {
            console.error('Fetch error:', error);
            throw error;
        }
    }

    render() {
        const { name, email, subject, lastname, message, error, isSubmitting, submitStatus } = this.state;

        return (
            <form onSubmit={this.submitHandler} className="form">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-field">
                            <input 
                                value={name} 
                                onChange={this.changeHandler} 
                                type="text" 
                                name="name" 
                                placeholder="Name"
                                disabled={isSubmitting}
                            />
                            <p className="error-text">{error.name ? error.name : ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-field">
                            <input 
                                value={lastname} 
                                onChange={this.changeHandler} 
                                type="text" 
                                name="lastname" 
                                placeholder="Lastname"
                                disabled={isSubmitting}
                            />
                            <p className="error-text">{error.lastname ? error.lastname : ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-field">
                            <input 
                                onChange={this.changeHandler} 
                                value={email} 
                                type="email" 
                                name="email" 
                                placeholder="Email"
                                disabled={isSubmitting}
                            />
                            <p className="error-text">{error.email ? error.email : ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-field">
                            <input 
                                onChange={this.changeHandler} 
                                value={subject} 
                                type="text" 
                                name="subject" 
                                placeholder="Subject"
                                disabled={isSubmitting}
                            />
                            <p className="error-text">{error.subject ? error.subject : ''}</p>
                        </div>
                    </div>
                    
                    <div className="col-lg-12">
                        <div className="form-field">
                            <textarea 
                                name="message" 
                                placeholder="Message"
                                value={message}
                                onChange={this.changeHandler}
                                disabled={isSubmitting}
                            ></textarea>
                            <p className="error-text">{error.message ? error.message : ''}</p>
                        </div>
                    </div>
                    
                    {/* Status Messages */}
                    {submitStatus === 'success' && (
                        <div className="col-lg-12">
                            <div className="success-message" style={{color: 'green', padding: '10px', background: '#f0fff0', borderRadius: '5px'}}>
                                ✅ Message sent successfully!
                            </div>
                        </div>
                    )}
                    
                    {submitStatus === 'error' && (
                        <div className="col-lg-12">
                            <div className="error-message" style={{color: 'red', padding: '10px', background: '#fff0f0', borderRadius: '5px'}}>
                                ❌ Failed to send message. Please try again.
                            </div>
                        </div>
                    )}
                    
                    <div className="col-lg-12">
                        <div className="form-submit">
                            <button 
                                type="submit" 
                                className="theme-btn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin"></i>
                                        Sending...
                                    </>
                                ) : (
                                    'Send Message'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default ContactForm;